import request from '@/utils/http';
// 查询 bucket 列表
export const getTasks = (params) => {
    return request({
        url: `/api-bms-web/feeTask/loadHeaders`,
        method: 'get',
        params: params
    });
};
export const getFineTasks = (params) => {
    return request({
        url: `/api-bms-web/supplierfinedebit/loadHeaders`,
        method: 'get',
        params: params
    });
};
export const getFineDetails = (params) => {
    return request({
        url: `/api-bms-web/supplierfinedebit/loadDetails`,
        method: 'get',
        params: params
    });
};
export const getCostDetails = (params) => {
    return request({
        url: `/api-bms-web/feeTask/loadTaskDetails`,
        method: 'get',
        params: params
    });
};
export const getFeeDetails = (params) => {
    return request({
        url: `/api-bms-web/feeTask/loadFeeDetails`,
        method: 'get',
        params: params
    });
};
export const saveDetails = (data) => {
    return request({
        url: `/api-bms-web/feeTask/saveDetails`,
        method: 'post',
        data: data
    });
};
export const confirm = (data) => {
    return request({
        url: `/api-bms-web/feeTask/confirm`,
        method: 'post',
        data: data
    });
};

export const getUploadLists = (data) => {
    return request({
        url: `/api-bms-web/feeTask/upload`,
        method: 'post',
        data
    });
};

export const getExportLists = (params) => {
    return request({
        url: `/api-bms-web/feeTask/exportFeeDetail`,
        method: 'get',
        params,
        responseType: 'arraybuffer'
    });
};
export const exportLoadHeaders = (params) => {
    return request({
        url: `/api-bms-web/supplierfinedebit/exportLoadHeaders`,
        method: 'get',
        params,
        responseType: 'arraybuffer'
    });
};

export const getTaskRecall = (data) => {
    return request({
        url: `/api-bms-web/feeTask/taskRecall?feeTaskCode=${data}`,
        method: 'put'
    });
};

export const getExport = (params) => {
    return request({
        url: `/api-bms-web/feeTask/exportTaskDetailMo`,
        method: 'get',
        params,
        responseType: 'arraybuffer'
    });
};

export const getImportTemplate = (data) => {
    return request({
        url: `/api-bms-web/feeTask/uploadTaskDetail`,
        method: 'post',
        data
    });
};
